<template>
    <div class="border border-gray-200 bg-white rounded-md shadow-md p-2.5">
        <document-folder
            v-for="folder in filtered_folders"
            :key="folder.id"
            :folder="folder"
            :property_id="property.id"
            :count="document_counts[folder.id]"
            :selected="! has_filter && (folder.id === selected_folder_id)"
            @click="selectedFolder(folder.id)"
            @updatedDocument="updatedDocument"
            @selectFolder="selectFolder"
        />

        <div class="flex items-center justify-between py-3 cursor-pointer pl-3"
            @click="addFolder"
        >
            <div class="flex items-start leading-tight text-sm italic text-gray-600 hover:text-blue-600"
            >
                <folder-plus-icon size="16" class="mr-2" />

                New Folder
            </div>
        </div>

        <document-folder-create-modal
            :show="show_create_folder_modal"
            :property_id="property.id"
            @closed="createFolderModalClosed"
            @createdFolder="createdFolder"
        />
    </div>
</template>

<script>
import DocumentFolder from './document-folder.vue';
import DocumentFolderCreateModal from './document-folder-create-modal.vue';
import { FolderPlusIcon } from 'vue-feather-icons';

export default {
    components: {
        DocumentFolder,
        DocumentFolderCreateModal,
        FolderPlusIcon,
    },

    props: {
        folders: {},
        document_counts: {},
        property: {},
        selected_folder: {},
        has_filter: { default: false },
    },

    data() {
        return {
            selected_folder_id: this.selected_folder ? this.selected_folder.id
                : (this.folders.length ? this.folders[0].id : null),
            // show_edit_folder_modal: false,
            show_create_folder_modal: false,
            folder_drop: [],
        }
    },

    methods: {
        addFolder() {
            this.show_create_folder_modal = true;
        },
        createFolderModalClosed() {
            this.show_create_folder_modal = false;
        },
        createdFolder(folder) {
            this.$emit('created_folder', folder);
        },
        updatedFolder(folder) {
            this.$emit('updated_folder', folder);
        },
        deletedFolder(folder) {
            this.$emit('deleted_folder', folder);
        },
        updatedDocument(document) {
            this.$emit('updated_document', document);
        },
        selectFolder(folder_id) {
            this.selected_folder_id = folder_id;
        },
        selectedFolder(folder_id) {
            this.selected_folder_id = folder_id;
            this.$emit('click');
        },
    },

    computed: {
        is_buyer_side() {
            return this.property.deal.our_purchase;
        },
        is_seller_side() {
            return this.property.deal.our_sale;
        },
        filtered_folders() {
            return this.folders.filter(folder => {
                return (this.is_buyer_side && folder.is_buyer_side)
                    || (this.is_seller_side && folder.is_seller_side)
                    || (! folder.is_buyer_side && ! folder.is_seller_side);
            });
        },
    },

    watch: {
        selected_folder_id: {
            handler(value) {
                this.$emit('selected_folder', value);
            },
        },
    },
}
</script>
